import { Box, Skeleton, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import SensitiveInfoTypography from '~/components/SensitiveInfoTypography';
import ReviewStatus from '~/components/Structures/ReviewStatus';
import { StructureSetReadModel } from '~/domain/readmodels/StructureSetReadModel';
import { cutUID } from '~/utils/string';

type InputDataDisplayProps = {
    structureSet?: StructureSetReadModel;
    isLoading?: boolean;
};

const SkeletonLoader = () => (
    <Box>
        <Skeleton variant="text" width="20%" height={24} />
        <Skeleton variant="text" width="60%" height={18} />
        <Skeleton variant="text" width="30%" height={18} />
    </Box>
);

export default function StructureSetDataPreview({
    structureSet,
    isLoading,
}: InputDataDisplayProps) {
    return isLoading ? (
        <SkeletonLoader />
    ) : structureSet ? (
        <Box width="100%" position="relative">
            <Box
                display="flex"
                gap={1}
                alignItems="center"
                justifyContent="space-between"
            >
                <Box display="flex" gap={0.5} alignItems="end">
                    <Typography>RTSTRUCT</Typography>
                    <Typography color="primary" fontSize={12} lineHeight={1.8}>
                        ({structureSet?.roiArray.length})
                    </Typography>
                </Box>
                <ReviewStatus
                    status={structureSet.approvalStatus}
                    fontSize={11}
                />
            </Box>
            <Typography
                fontSize={12}
                sx={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                }}
            >
                <SensitiveInfoTypography>
                    {structureSet.structureSetLabel}
                </SensitiveInfoTypography>
            </Typography>
            <Typography fontSize={12} variant="body2">
                <SensitiveInfoTypography>
                    {cutUID(structureSet?.dicomUid, 4, 6)}
                </SensitiveInfoTypography>
            </Typography>
        </Box>
    ) : (
        <Typography variant="body2">
            <FormattedMessage id="noStructureSetSelected" />
        </Typography>
    );
}
